<template>
<v-sheet :dark="dark" class="fill-height" :color="!dark ? 'background' : null" v-if="order">
   <page-header :banner-height="250"
      :collapse-toolbar="false"
      :is-toolbar="false"
      :banner="banner"
      :toolbar-title="title"
      back="/dashboard"
      :dark="dark"
      :align-end="true"
 >
 <template slot="extension">
 <v-toolbar flat dense  class="font-weight-light text-subtitle-1 primary--text">
    <v-toolbar-title v-if="order.deliver && order._address" class="pl-0 mb-1">
      <v-icon color="primary" class="mx-2">mdi-truck-delivery-outline</v-icon>{{order._address.name}}
    </v-toolbar-title>
    <v-toolbar-title v-else class="pl-0 mb-1"><v-icon class="mx-2" color="primary">mdi-store</v-icon>Afhalen</v-toolbar-title>
    <v-spacer></v-spacer>
    <div class="text-h6 pa-2">
    {{order.due | moment('HH:mm')}}
    </div>
 </v-toolbar>
 </template>
<!--v-toolbar flat slot="extension" :dark="dark" :light="!dark" v-if="order">

   <v-chip-group class="px-3 mt-1" active-class="primary" mandatory>
     <v-chip label dark
        class="text-subtitle-1"
        style="background-color:transparent"
      >
        Bestelling #{{order.number}}
      </v-chip></v-chip-group>
      <v-spacer></v-spacer>
      <v-icon class="mt-3" size="28" :color="dark ? null : 'primary'" v-if="order.deliver">mdi-truck-delivery-outline</v-icon>
      <v-icon class="mt-3" size="28" :color="dark ? null : 'primary'" v-else>query_builder</v-icon>
      <span class="ma-2" :class="{'primary--text': !dark}">{{order.due | moment('HH:mm')}}</span>
</v-toolbar-->
<template slot="hero">
       <div class="mb-5"> 
        <v-avatar v-if="host.logo" class="app-btn mt-7" size="70" style="z-index:10;box-shadow: 0px 7px 8px -4px rgb(0 0 0 / 20%), 0px 13px 19px 2px rgb(0 0 0 / 14%), 0px 5px 24px 4px rgb(0 0 0 / 12%) !important;">
          <v-img :src="host.logo"></v-img>
        </v-avatar>
       <h1 class="text-h5 white--text">{{ host.name }}</h1>
       </div>
        </template>
 </page-header>
 <v-container class="pa-0 main-content mt-5">
    <v-overlay :value="loading" color="primary" v-if="loading" opacity="1">
        <v-progress-circular indeterminate size="64" @click="loading=false"></v-progress-circular>
      </v-overlay>
   <v-alert v-if="order && !loading && !isSuccess" color="error" dark class="mt-13 rounded-xl text-center">
      Er is iets misgegaan met de iDeal betaling({{order.payment? order.payment.status : 'geen'}}). <br>
      <span v-if="allowCash || allowPin">Wil je de bestelling betalen bij het {{order.deliver ? 'bezorgen' : 'afhalen'}}?</span><br><br>
     <v-btn v-if="allowCash" dark @click="setPayment('cash')" class="mr-5">Contant</v-btn>
     <v-btn v-if="allowPin" dark @click="setPayment('pin')" class="mr-5">PIN</v-btn>
     <v-btn dark @click="cancelOrder" text small class="mt-5">Bestellling annuleren</v-btn>
     
     <br><br>
      Je kunt ons altijd even bellen op <a :href="`callto:${order._host.phone}`" class="white--text text-body-1">{{order._host.phone}}</a>
   </v-alert>
   <template v-else>
   <v-card-title class="primary--text font-weight-light mb-0">Bedankt voor je bestelling!
     <v-spacer></v-spacer>
        <b>#{{order.number}}</b>
   </v-card-title>
   
       <v-card-text v-if="order.asap && order.deliver">We brengen deze zo snel mogelijk bij je langs.</v-card-text>
       <v-card-text v-if="!order.asap && order.deliver">We brengen deze om {{order.due | moment('HH:mm')}} bij je langs.</v-card-text>
       <v-card-text v-if="order.asap && !order.deliver">We maken deze zo snel mogelijk(om {{order.due | moment('HH:mm')}}) klaar.</v-card-text>
       <v-card-text v-if="!order.asap && !order.deliver">Deze staat klaar voor je om {{order.due | moment('HH:mm')}}.</v-card-text>
      
   </template>
 </v-container>
  <v-container class="pa-0 main-content">
            <v-row>
      <v-col cols="12" md="6" lg="6" xl="6" :order="largeScreen ? 1 : 2">
 <v-card  tile class="mx-auto pt-3 " outlined>
   
  <template v-if="isSuccess">
    <template v-if="order._stamps>=stampmax">
    <v-card-title class="primary--text font-weight-light mb-0">Stempels</v-card-title>
     <v-alert type="success" class="mx-3" icon="verified">
              Je hebt een volle kaart en krijgt een extra snack of drankje bij je volgende bestelling
      </v-alert>
    </template>
    <template v-else>
      <template v-if="order.collected">
        <v-card-title class="primary--text font-weight-light mb-0">Je krijgt een gratis snack of drankje</v-card-title>
        <v-card-text v-if="stamps>0">Je hebt nog <b class="primary--text">{{stamps}} stempel<span v-if="stamps>1">s</span></b> over.</v-card-text>
      </template>
      <template v-else>
        <v-card-title class="primary--text font-weight-light mb-0" v-if="order.stamps==1">Je hebt een nieuwe stempel </v-card-title>
        <v-card-title class="primary--text font-weight-light mb-0" v-else>Je hebt {{order.stamps}} nieuwe stempels</v-card-title>
        <v-card-text>Je hebt al <b class="primary--text">{{stamps}} stempel<span v-if="stamps>1">s</span></b> gespaard. Bij elk {{stampmax}}<sup>e</sup> stempel krijg je een gratis snack of drankje.</v-card-text>
      </template>
    </template>
   
   
    <v-card-text class="pr-10">
    <v-rating class="do-wrap"
                          :value="Math.abs(stamps)"
                          :length="stampmax"
                          readonly
                        >
                          <template v-slot:item="props">
                            <v-divider v-if="props.index > 0 && props.index % stampmax == 0" class="my-3"></v-divider>
                            <stamp :animate="false"
                                  :value="{stamp: props.isFilled ? host.stamp || host.logo : '/img/stamp-empty.png'}"
                                  :empty="!props.isFilled"
                                  :text="host.name"
                                >
                                </stamp>
                            <!--v-icon v-if="false"
                              :color="props.isFilled ? 'success' : ''"
                            >verified</v-icon-->
                          </template>
                        </v-rating>
          </v-card-text>
    <v-card-text class="text-center my-5">Voor vragen en opmerkingen kun je ons altijd bellen op <br> <a :href="`callto:${order._host.phone}`" class="primary--text text-body-1">{{order._host.phone}}</a></v-card-text>
  </template>
  
   
 </v-card>
      </v-col>
          
            <v-col cols="12" md="6" lg="6" xl="6" :order="largeScreen ? 2 : 1">
               <add-host v-model="showAddHost" type="RELATIONS" @success="showAddHost=false" hint="Vul de naam zodat wij contact met ze op kunnen nemen."></add-host>
    <v-card-text>Bestel je nog bij een ander restaurant die nog geen gebruik maakt van Eetplein? Laat het ons weten zodat je gemakkelijk bij hen kunt bestellen en ook zij kunnen profiteren van de voordelen van Eetplein!</v-card-text>
    <center><v-btn @click="showAddHost=true" text color="primary">Restaurant aanmelden</v-btn></center>
 <v-card color="primary" dark class="mx-3" flat>
   
    <order-table :value="order" outlined class="mt-5"></order-table>
    
    </v-card>
     <v-footer :fixed="!largeScreen" color="transparent" class="justify-center main-content"  :height="platform=='ios' ? 90 : null">
      <v-btn :class="{'mb-5': platform=='ios'}" to="/dashboard" large class="white--text flex-grow-1" color="green" :disabled="!isSuccess">Naar mijn startscherm
      <phone-validator ref="phonecheck" v-if="!validated && !isSuccess" v-model="user.phone" :phone="user.phone" :user="user" dense @valid="validateUser" :force="true"></phone-validator>
      </v-btn>
    </v-footer>
            </v-col>
              </v-row>
 </v-container>
  <v-card flat dark tile class="mt-15" :class="{'mb-15': !largeScreen}">
           
            <v-container class="mx-auto">
              <v-row>
                <v-col cols="12" md="6">
                <v-card-title class="px-0">{{host.name}}</v-card-title>
                <external-link v-if="host._address" v-model="host._address.name" :label="host._address.name" icon="pin_drop" address class="mr-2"></external-link><br>
                <external-link v-model="host.phone" :label="host.phone" icon="support_agent" phone class="mr-2"></external-link>
                </v-col>
              <v-col cols="12" md="6">
                </v-col>
              
              </v-row>
              
            </v-container>
        </v-card>
  </v-sheet>
  <v-alert v-else-if="!loading" @click="home" class="ma-5" type="error">
    Er is iets misgegaan, klik hier om terug te gaan naar het beginscherm.
  </v-alert>
</template>

<script>
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { mapActions, mapGetters } from "vuex";
import OrderTable from '../components/OrderTable.vue'
import PageHeader from "../components/PageHeader.vue";
import headerItem from '@/modules/headerItem'
import stamp from "@/components/stamp";
import phoneValidator from "../components/phoneValidator.vue";
import externalLink from '@/components/externalLink'
import addHost from "@/components/addHost.vue";
export default {
   metaInfo () {
      return {
        title: this.host ? `☑ Officiële website ${this.host.name}` : 'Eetplein'
      }
    },
 mixins: [headerItem],
    components: {
    OrderTable,
    PageHeader,
    stamp, 
    phoneValidator,
    externalLink,
    addHost
  },
  data() {
    return {
      loading:true,
      order: null,
      stamps: 0,
      validated: false,
      settype: null,
      showAddHost: false,
    };
  },
  computed: {
    ...mapGetters(["orders", "credits", "user"]),
    index() {
      return this.$route.params.index
    },
    host() {
      if (!this.order) return {banner: this.$config.page.banner, name: "Mijn eetplein", type: this.$config.menus}
      return this.order ? this.order._host  :{}
   },
   stamp(){
     return {name: this.host.name, stamp: this.host.stamp || this.host.logo}
   },
   stampmax(){
      return this.host.order.stampmax || this.$config.stamps.max
   },
   stampvalue(){
      return this.host.order.stampvalue || this.$config.stamps.value
   },
   allowPin(){
    
     if (!this.host.order) return false
    //if (!this.order.deliver) return true
     if (this.host.order.nopin == true) return false
     if (this.host.order.ideal_force == true) return false
     if (this.host.order.ideal_first == true && this.order.first == true) return false
     return true
   },
   allowCash(){
     if (!this.host.order) return false
     if (!this.order.deliver) return true
     if (this.host.order.ideal_force == true) return false
     if (this.host.order.ideal_first == true && this.order.first == true) return false
     return true
   },
    banner(){
      return this.host.banner;
    },
    title() {
      return this.host.name
    },
    isSuccess(){
      if (!this.order.payment) return false
      if (['pin','cash'].includes(this.order.payment.type)) return true
      if (['ideal'].includes(this.order.payment.type) && this.order.payment.paid == true) return true
      return false
    },
  },
  
  mounted() {
    this.load()
  },
  watch: {
    
  },
  methods: {
  ...mapActions([
      'setUser',
    ]),
    async load() {
      this.loading = true
      try{
      this.validated = this.user._verified ? true : false
      let response = await this.$http.post("/api/order/info", {index: 'order/' + this.index});
      this.order = response.data[0];
      if (!this.order) return this.$router.push({path: '/dashboard'})
      this.stamps = this.order._stamps + (this.order._stamps < 0 ? this.credits : 0)
      if (!this.order.payment.paid && this.order.payment.type == 'ideal'){ //load status
         if (this.$route.query && this.$route.query.type=='checkout' && (this.order.payment.status == 'open' || this.order.payment.status == 'pending')) return this.gotoPayment()
          if (this.order.payment.id){
              response = await this.$http.get("/api/payment/check/" + this.order.payment.id);
              this.order.payment = response.data.payment
          }
          if (!this.order.payment.paid) {//reset stamps
              await this.$http.put("/api/" + this.order._id,{stamps: 0});
              this.order._stamps -= this.order.stamps
          }
          
      }
       
      }catch(e){

      }
      this.loading = false
      
      
      
      //order._stamps
      //if (this.isCustomer)
    },
    async gotoPayment(){
      //document.location.href.replace('checkout','orders')
        if (Capacitor.isNativePlatform()){
            Browser.addListener("browserFinished", (info) => {
                this.$router.replace({'query': null});
                this.load()
              })
            let w = await Browser.open({ url: this.order.payment.url });
            
        }else{
              return document.location = this.order.payment.url
          }
         
    },
    async cancelOrder(){
      if ( await this.$root.$confirm(
        "Bestelling annuleren?",
        "Weet je zeker dat je deze bestelling wilt verwijderen?",
        { yes: "Ja", cancel: "Nee" }
      )) {
          await this.$http.put("/api/" +  this.order._id + '/delete',{});
          this.home()
      }
    },
    home(){
      this.$router.push({name: 'dashboard'})
    },
    async validateUser(){
      let response = await this.$http.get("/api/auth/me");
      let user = response.data.user
      if (!user) return false
      this.setUser(user);
      this.validated = user._verified ? true : false
      if (this.settype) return this.setPayment(this.settype)
      return user
    },
    async setPayment(type){
        if (!type) return false
        if (type=='cash' && !this.allowCash) return false
        if (type=='pin' && !this.allowPin) return false
        this.settype = type
        if (!this.validated && !this.$refs.phonecheck) return false
        if (!this.validated) return this.$refs.phonecheck.getCode()
        let response = await this.$http.put("/api/order/payment/" + this.index + '/' + type,{});
        this.order.payment = response.data;
        this.order.stamps = this.stampvalue > 0 ? Math.round(this.order.amount / this.stampvalue) : 1
        this.order.amount = this.order.amount-this.order.transaction
        this.order.transaction = 0
        await this.$http.put("/api/" + this.order._id,{stamps: this.order.stamps, transaction: 0, amount: this.order.amount});
        this.order._stamps += this.order.stamps
        this.stamps = this.order._stamps
    },
    
  },
};
</script>
<style >
.theme--dark.v-chip--active:hover::before,
.theme--dark.v-chip--active::before {
  display: none;
}

</style>